import React from 'react';
import Button from '../atoms/Button/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { List } from 'lodash';


type Props = {
    active: string
    onChange: (t: string) => void
    buttonList: Array<string>
}

const Tabs: React.FC<Props> = ({active, onChange, buttonList}) => (
        <ButtonGroup variant='outlined' color={'primary'} disableElevation disableRipple>
            {
                buttonList.map((buttonName: string, i: number) => {                    
                    return (
                        <Button 
                            key={`btn${i}_${buttonName}`}
                            variant={active === buttonName ? 'contained' : 'outlined'}
                            disableElevation
                            disableRipple
                            onClick={() => onChange(buttonName)}>
                                {buttonName}
                        </Button>)
                })
            }
        </ButtonGroup>
    )

export default Tabs;
